// extracted by mini-css-extract-plugin
module.exports = {"crossSiteLabel":"ji","zenCrossSiteLabel":"ki","vrsnlCrossSiteLabel":"li"};